<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-06 13:48:01
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div>

    </div>
</template>
<script>
export default {
    data () {
        return {

        };
    },
    esvReady() {
        // this.oauthUrl();
    },
    methods: {
        // 授权
        oauthUrl() {
            const ths = this;
            const params = {
                merchantCode: ths.$route.query.merchantCode,
                url: window.location.href
            };
            ths.$doRequest(
                {
                    url: '/oauth/oauthUrl',
                    params: params,
                    complete: function() {}
                },
                function(data) {
                    ths.ESVStorage.putSavedValue('couponTemplateCode', ths.$route.query.couponTemplateCode);
                    window.location.href = data.result.replace('blankTo', 'receiveCoupon');
                }
            );
        }
    }
};
</script>
<style lang="scss" scoped>
.couponBox{
    text-align: center;
    padding:20px 0;
    letter-spacing: 2px;
    position: relative;
    .imgPosition{

    }
    h5{
        position: absolute;
        left:50px;
        top:40px;
        span{
            padding-left:10px;
            color:#fff;
            font-size:16px;
        }
    }
    .price{
        position: absolute;
        right:50px;
        top:65px;
        color:#fff;
        font-size: 14px;
    }
    .time{
        position: absolute;
        left:50px;
        bottom:37px;
        color:#fff;
        font-size: 16px;
        text-align: left;
        p{
            width:80%;
        }
    }
}
</style>
